// COM-640 fix wave (re-review, coverage gap): frontend-side mirror of
// backend/src/lib/addSourceInput.ts's `validateAddSourceInput` - the exact
// guard the real `addSource` socket handler applies ("url is required, name
// is not"). `mockSocket.ts`'s `addSource` case uses this so a name-required
// regression on either side of the real/mock split is caught by the SAME
// rule, rather than the mock silently re-diverging from the backend (which
// is exactly what happened before COM-640's Critical 1 fix - the mock had
// no guard at all while the real handler still refused a blank name).
//
// Kept deliberately independent of the backend module (different package,
// no shared build step) - if the backend's rule ever changes, this file
// needs a matching edit. Not the same thing as `addSourceForm.ts`'s
// `validateAddSource`: that one is the DIALOG's client-side, stricter
// pre-submission check (a real URL shape, via `isValidSourceUrl`); this one
// is the narrower, defense-in-depth check the SERVER itself applies to
// whatever actually reaches it over the wire.
export interface AddSourceInput {
  name?: string;
  url?: string;
}

/** `null` when `data` is valid; otherwise the exact `error` message the
 * real `addSource` handler would emit back to the client. */
export function validateAddSourceInput(data: AddSourceInput): string | null {
  if (!data.url) {
    return 'URL is required';
  }
  return null;
}
